<div echarts [options]="options" class="echart"></div>
